import { render, staticRenderFns } from "./CreateLead.vue?vue&type=template&id=a860cfd4&"
import script from "./CreateLead.vue?vue&type=script&lang=js&"
export * from "./CreateLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports